/** No-reply senders (the "no-reply senders and the bounce block" round, 2026-11-02; brief docs/briefs/no-reply-and-bounce-block-round.md rule
 *  6, red-team question 2): a robot address that takes no mail, recognised by the name before the @, never by guessing. Pure and free of mail
 *  code, so the web's To line reads the same rule as the inbound pipeline and the automatic send (`@omnabase/shared/mail` re-exports it). */

/** the names that count alone: the brief's list, the spelled-out forms of "no reply" and WordPress's own mailer (most WordPress contact forms) */
const ALONE = new Set(["no-reply", "noreply", "no_reply", "no.reply", "do-not-reply", "do_not_reply", "do.not.reply", "donotreply", "notification", "notifications", "mailer", "bounce", "bounces", "alert", "alerts", "wordpress"]);
/** the "no reply" words that also count joined to others by "-", "_" or "." ("noreply-dmarc-support", "forwarding-noreply", "no-reply-aws") */
const JOINED: readonly (readonly string[])[] = [["noreply"], ["donotreply"], ["no", "reply"], ["do", "not", "reply"]];

/** the name before the @, lower-cased, without a "+tag" */
const localPart = (email: string): string => {
  const at = email.lastIndexOf("@");
  const local = (at < 0 ? email : email.slice(0, at)).trim().toLowerCase();
  const plus = local.indexOf("+");
  return plus < 0 ? local : local.slice(0, plus);
};
/** does the run of words appear in a row among the parts? */
const holdsRun = (parts: readonly string[], run: readonly string[]): boolean => parts.some((_, i) => run.every((w, j) => parts[i + j] === w));

/** true for a robot sender: the brief's names in any case with a "+tag" allowed, the "no reply" words joined to others, and "wordpress@";
 *  "alerts", "bounce" and the other words count only alone ("founder.alerts@" stays a person) */
export function isNoReplyAddress(email: string | null | undefined): boolean {
  if (!email || !email.includes("@")) return false;
  const local = localPart(email);
  if (ALONE.has(local)) return true;
  const parts = local.split(/[-_.]/);
  return parts.length > 1 && JOINED.some((run) => holdsRun(parts, run));
}
